/* unplugin-vue-components disabled */import { render } from "./prize.vue?vue&type=template&id=e17d029a&scoped=true"
import script from "./prize.vue?vue&type=script&lang=js"
export * from "./prize.vue?vue&type=script&lang=js"

import "./prize.vue?vue&type=style&index=0&id=e17d029a&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e17d029a"]])

export default __exports__